import { StyleSheet } from "react-native";

const style = StyleSheet.create({
  spinnerWrapper: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    justifyContent: "space-around",
  },
});

export { style };
